/**
 * Google Analytics 4 helper for ReplyDriven
 * Provides simple conversion tracking for key events
 */

// Check if gtag is available
const isGtagAvailable = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

/**
 * Track a custom GA4 event
 * @param {string} eventName - Event name (e.g., 'sign_up', 'store_connected')
 * @param {object} params - Optional event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (!isGtagAvailable()) {
    console.debug('[GA4] gtag not available, skipping event:', eventName);
    return;
  }
  
  window.gtag('event', eventName, params);
};

/**
 * Track signup completion (GA4 recommended event)
 * @param {string} method - Signup method (e.g., 'google')
 */
export const trackSignup = (method = 'google') => {
  trackEvent('sign_up', { method });
};

/**
 * Track Shopify store connection (custom conversion)
 */
export const trackStoreConnected = () => {
  trackEvent('store_connected', {
    event_category: 'onboarding',
    event_label: 'shopify'
  });
};

/**
 * Track subscription started (custom conversion)
 * @param {string} plan - Plan name (operator/growth)
 */
export const trackSubscription = (plan) => {
  trackEvent('begin_checkout', {
    currency: 'USD',
    items: [{ item_name: `ReplyDriven ${plan}` }]
  });
};

/**
 * Track onboarding completion
 */
export const trackOnboardingComplete = () => {
  trackEvent('tutorial_complete', {
    event_category: 'onboarding'
  });
};

export default {
  trackEvent,
  trackSignup,
  trackStoreConnected,
  trackSubscription,
  trackOnboardingComplete
};
